import { createContext } from "react";

import { NavbarContextValue } from "../types/navbar";

export const NavbarContext = createContext<NavbarContextValue>({} as NavbarContextValue);
